import { useState, useCallback } from "react";

const shots = [
  {
    src: "/images/tiirada/home-tirador.png",
    alt: "TiiRADA Tirador home screen showing available gigs",
    caption: "Tirador feed — browse available gigs",
  },
  {
    src: "/images/tiirada/gig-details-1.png",
    alt: "TiiRADA gig details screen",
    caption: "Gig details — see requirements and bid",
  },
  {
    src: "/images/tiirada/in-app-messaging.png",
    alt: "TiiRADA in-app messaging between client and tirador",
    caption: "In-app messaging — coordinate directly",
  },
  {
    src: "/images/tiirada/portfolio.png",
    alt: "TiiRADA Tirador portfolio and profile",
    caption: "Portfolio — showcase your work",
  },
];

export default function ScreenshotCarousel() {
  const [idx, setIdx] = useState(0);

  const prev = useCallback(() => setIdx((i) => (i === 0 ? shots.length - 1 : i - 1)), []);
  const next = useCallback(() => setIdx((i) => (i === shots.length - 1 ? 0 : i + 1)), []);

  return (
    <div style={{
      position: "relative",
      margin: "3rem auto",
      maxWidth: "320px",
      userSelect: "none",
    }}>
      <div style={{
        position: "relative",
        width: "100%",
        aspectRatio: "9 / 19",
        overflow: "hidden",
        borderRadius: "16px",
        background: "var(--bg-secondary)",
      }}>
        {shots.map((s, i) => (
          <img
            key={i}
            src={s.src}
            alt={s.alt}
            draggable={false}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "contain",
              opacity: i === idx ? 1 : 0,
              transition: "opacity 0.4s ease",
              pointerEvents: i === idx ? "auto" : "none",
              cursor: "zoom-in",
              borderRadius: "16px",
            }}
          />
        ))}
      </div>

      <div style={{
        display: "flex",
        justifyContent: "center",
        gap: "0.75rem",
        marginTop: "1rem",
      }}>
        <button
          onClick={prev}
          aria-label="Previous screenshot"
          style={{
            background: "var(--bg-secondary)",
            border: "1px solid var(--border-strong)",
            color: "var(--text-primary)",
            width: 36,
            height: 36,
            borderRadius: "50%",
            cursor: "pointer",
            fontSize: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s ease",
          }}
        >
          &#8592;
        </button>

        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}>
          {shots.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              aria-label={`Go to screenshot ${i + 1}`}
              style={{
                width: i === idx ? 10 : 6,
                height: i === idx ? 10 : 6,
                borderRadius: "50%",
                border: "none",
                background: i === idx ? "var(--accent-cyan)" : "var(--text-muted)",
                cursor: "pointer",
                padding: 0,
                transition: "all 0.2s ease",
              }}
            />
          ))}
        </div>

        <button
          onClick={next}
          aria-label="Next screenshot"
          style={{
            background: "var(--bg-secondary)",
            border: "1px solid var(--border-strong)",
            color: "var(--text-primary)",
            width: 36,
            height: 36,
            borderRadius: "50%",
            cursor: "pointer",
            fontSize: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s ease",
          }}
        >
          &#8594;
        </button>
      </div>

      <p style={{
        textAlign: "center",
        fontSize: "0.8rem",
        opacity: 0.6,
        marginTop: "0.75rem",
        marginBottom: 0,
      }}>
        {shots[idx].caption}
      </p>
    </div>
  );
}
